
import { defineComponent } from 'vue';
import PrologueTemplate from '@/components/templates/prologue/PrologueTemplate.vue';
import { pageview } from 'vue-gtag';

export default defineComponent({
  name: 'Prologue',
  methods: {
    track() {
      pageview({ page_path: '/prologue' });
    },
  },
  components: { PrologueTemplate },
});
